export default __webpack_public_path__ + "static/media/menusvgg.284e2000.svg";